// removed by extract-text-webpack-plugin
module.exports = {"container":"_2GQSbh-jbWM4u75bJ9QJ4C"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Preparation/Create/Save/styles.css
// module id = 3267
// module chunks = 0